<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close(false)"></div>
      <div class="modalContent">
        <div class="close" v-on:click="close(false)"></div>
        <h4 class="title">Select Background</h4>
        <div class="mainBg">
          <div class="bgNav l" v-if="navIdx > 0" v-on:click="navPrev"></div>
          <div class="bgNav r" v-if="navIdx < 3" v-on:click="navNext"></div>
          <div class="bgCnt">
            <div class="bgSc" :class="`nav-${navIdx}`">
              <div class="bgItem bg-1" v-on:click="selectBg(1)"></div>
              <div class="bgItem bg-2" v-on:click="selectBg(2)"></div>
              <div class="bgItem bg-3" v-on:click="selectBg(3)"></div>
              <div class="bgItem bg-4" v-on:click="selectBg(4)"></div>
              <div class="bgItem bg-5" v-on:click="selectBg(5)"></div>
              <div class="bgItem bg-6" v-on:click="selectBg(6)"></div>
            </div>
          </div>
        </div>
        <div class="customBg">
          <div class="fieldGroup">
            <label>Custom Image</label>
            <div class="field" v-on:click="selectMedia">
              <div class="fieldImg" v-if="media && media.imageSm"
                :style="{'background-image': `url(${media.imageSm})`}"></div>
              <div class="fieldImg noImg" v-else></div>
              <div class="mediaLabel" v-if="media && media.name">
                {{media.name}}</div>
              <div class="mediaLabel" v-else-if="media">
                Selected Media</div>
              <div class="mediaLabel" v-else>Select Media</div>
              <div class="fieldMore"></div>
            </div>
          </div>
        </div>
      </div>
      <MediaSelector ref="mediaSelector"/>
    </div>
  </transition>
</template>

<script>
import MediaSelector from '@/components/MediaSelector.vue';

export default {
  name: 'colorPicker',
  components: { MediaSelector },
  data() {
    return {
      show: false,
      next: null,
      navIdx: 0,
      bgId: 0,
      media: {},
    };
  },
  methods: {
    open(d, next) {
      this.bgId = d.id;
      this.media = d.media;
      this.show = true;
      this.next = next;
    },
    close(b, color) {
      this.show = false;
      if (this.next) this.next(b, color);
    },
    selectMedia() {
      this.$refs.mediaSelector.open({ type: 'image' }, (b, m) => {
        const media = m.gallery ? m.gallery[0] : m;
        if (this.type === 'media/image' && media.type !== 'image') {
          this.$refs.confirmDialog.open({
            title: 'Media Not Supported',
            desc: 'Only support media type image for this content',
            error: true,
          });
          return;
        }
        this.media = media;
        this.close(true, {
          id: this.bgId,
          type: 'custom',
          media: this.media,
        });
      });
    },
    navPrev() {
      this.navIdx -= 1;
    },
    navNext() {
      this.navIdx += 1;
    },
    selectBg(bg) {
      this.close(true, {
        type: 'fixed',
        id: bg,
        media: {},
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 99991;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      // padding: 30px 40px;
      border-radius: 5px;
      margin-top: -20px;
      overflow: hidden;
      width: 540px;
      box-sizing: border-box;
      .close{
        position: absolute;
        right: 10px; top: 10px;
        border-radius: 50%;
        width: 30px; height: 30px;
        background-image: url(../assets/close.png);
        background-size: 12px auto;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
        opacity: .5;
        transition: all .2s ease;
        &:hover{
          opacity: .8;
          background-color: #eee;
        }
      }
      h4.title{
        font-size: 24px;
        margin: 0;
        padding: 16px 40px 20px;
        font-weight: 600;
      }
      .mainBg{
        margin: 0 40px 30px;
        position: relative;
        .bgCnt{
          overflow: hidden;
        }
        .bgNav{
          position: absolute;
          width: 30px; height: 30px;
          z-index: 3;
          background-color: #fff;
          border-radius: 50%;
          top: 50%; margin-top: -15px;
          cursor: pointer;
          &:hover{
            box-shadow: 0 0 4px rgba(0, 0, 0, .2);
          }
          &:before{
            content: "";
            position: absolute;
            left: 0; right: 0; bottom: 0; top: 0;
            background-position: center;
            background-repeat: no-repeat;
            background-size: 12px auto;
          }
          &.l{
            &:before{
              background-image: url(../assets/left-arrow.png);
            }
            left: -15px;
          }
          &.r{
            &:before{
              background-image: url(../assets/right-arrow.png);
            }
            right: -15px;
          }
        }
        .bgSc{
          display: flex;
          width: 1600px;
          transition: all .3s ease;
          &.nav-1{
            margin-left: -170px;
          }
          &.nav-2{
            margin-left: -340px;
          }
          &.nav-3{
            margin-left: -550px;
          }
          .bgItem{
            width: 160px; height: 100px;
            background-size: cover;
            border-radius: 5px;
            margin-right: 10px;
            position: relative;
            cursor: pointer;
            &.bg-1{
              background-image: url(../assets/wallpaper/13756478_5309017.jpg);
            }
            &.bg-2{
              background-image: url(../assets/wallpaper/13756478_5309014.jpg);
            }
            &.bg-3{
              background-image: url(../assets/wallpaper/4264977_91352.jpg);
            }
            &.bg-4{
              background-image: url(../assets/wallpaper/indonesia-flag-wrinkled.jpg);
            }
            &.bg-5{
              background-image: url(../assets/wallpaper/dried-leaves-gray-blank.jpg);
            }
            &.bg-6{
              background-image: url(../assets/wallpaper/satellite.jpg);
            }
          }
        }
      }
      .customBg{
        padding: 0 40px 20px;
        .field{
          cursor: pointer;
          padding: 18px 40px 19px;
          padding-left: 64px;
          position: relative;
          .mediaLabel{
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-weight: 600;
            font-size: 17px;
          }
          .fieldImg{
            content: "";
            position: absolute;
            width: 46px; height: 46px;
            background-color: #ccc;
            border-radius: 5px;
            left: 6px; top: 6px;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            &.noImg{
              background-image: url(../assets/image-black.png);
              background-size: 24px auto;
              opacity: .36;
            }
          }
          .fieldMore{
            position: absolute;
            right: 6px; top: 11px;
            width: 34px; height: 34px;
            border-radius: 50%;
            background-size: 16px auto;
            background-position: center;
            background-repeat: no-repeat;
            background-image: url(../assets/right-arrow.png);
            opacity: .36;
          }
        }
      }
    }
  }
</style>
